// components/PrivateRoute.js
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserContext } from "../UserContext";

const PrivateRoute = ({ children }) => {
  const { user } = useContext(UserContext);
  const location = useLocation();

  if (!user?.user_id) {
    return (
      <Navigate
        to={`/signUp?redirect=${encodeURIComponent(
          location.pathname + location.search
        )}`}
        replace
      />
    );
  }

  return children;
};

export default PrivateRoute;
